import settings from '../../assets/settings.json';
import Cookies from 'js-cookie'

class FunctionFields {

  changeFavicon(what_type){
    let img_url = settings.API_BASE_URL+'favicon_green.ico';
    var favicon = document.querySelector('link[rel="icon"]') || document.createElement('link');

    favicon.type = 'image/png';
    favicon.rel = 'icon';
    favicon.href = 'favicon_green.ico';

    if (!document.querySelector('link[rel="icon"]')) {
      document.head.appendChild(favicon);
    } else {
      // Replace the existing <link> element with the new one
      document.head.removeChild(document.querySelector('link[rel="icon"]'));
      document.head.appendChild(favicon);
    }
  }


  convertDbStringToArray(db_data_str){
    
    let res_array = db_data_str.split('____');
    //console.log(res_array);

    let file_request_datas = [];
		for (let i = 0; i < res_array.length; i++) {
			let row_array = res_array[i].split('___');
      //console.dir(row_array);
      file_request_datas.push([row_array[0], row_array[1], row_array[2], row_array[3], row_array[4], row_array[5]]);
    }

    //console.dir(file_request_datas);

    return file_request_datas;
  }


  convertObjtoArray(order_data_files){
    let file_request_datas = [];
    for(let i = 0; i < order_data_files.length; i++){
      file_request_datas.push([order_data_files[i].id, order_data_files[i].what, order_data_files[i].who, order_data_files[i].file_path, order_data_files[i].timestamp, order_data_files[i].created_at]);
    }

    return file_request_datas;
  }
  
}

const addEveryoneFunction = new FunctionFields();

export { addEveryoneFunction };